import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, CampaignAdditionalMaterial } from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCampaignAdditionalMaterial: {} as Dict<CampaignAdditionalMaterial>,
	})
	.withGetters({
		byId: state => (campaignAdditionalMaterialId: number) => (
			state.storedCampaignAdditionalMaterial[campaignAdditionalMaterialId] ?? null
		),
	})
	.withMutations({
		STORE_CAMPAIGN_ADDITIONAL_MATERIAL (state, campaignAdditionalMaterial: CampaignAdditionalMaterial) {
			state.storedCampaignAdditionalMaterial = {
				...state.storedCampaignAdditionalMaterial,
				[campaignAdditionalMaterial.id]: campaignAdditionalMaterial,
			};
		},
	})
	.withActions({
		async get ({ commit }, campaignAdditionalMaterialId: number) {
			const { data } = await api.get(`/campaign-additional-material/${ campaignAdditionalMaterialId }`);

			commit('STORE_CAMPAIGN_ADDITIONAL_MATERIAL', data.payload);
		},
	});
